


























import Vue from 'vue'
import { FETCH_INFORMATION_DATA } from '@/store/action-types'
import { hexToRgba } from '@/services/hex-to-rgba'
import { Changelog } from '@/model/Changelog'
import ProgressCircular from '@/components/ProgressCircular.vue'
import moment from 'moment'
import _ from 'lodash'

interface ComponentData {
  informationData: Changelog[]
  loading: boolean
}

export default Vue.extend({
  name: 'InformationDialog',

  components: {
    ProgressCircular
  },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data (): ComponentData {
    return {
      informationData: [],
      loading: false
    }
  },

  computed: {
    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    async fetchInformationData(): Promise<void> {
      this.loading = true
      try {
        const data: any[] = await this.$store.dispatch(FETCH_INFORMATION_DATA)
        this.informationData = _.orderBy(
            data,
            (item) => moment(item.ReleaseDate, "DD.MM.YYYY HH:mm:ss").valueOf(),
            ['asc']
        )
      } catch {

      } finally {
        this.loading = false
      }
    }
  },

  mounted () {
    this.fetchInformationData()
  }

})
